<div class="container">
  <h4>Manage Sites</h4>
  <form>
    <div class="page-search mb-3">
      <div class="input-group">
        <input
          autofocus
          placeholder="Search Sites"
          id="txtSearch"
          class="form-control"
          type="text"
          [formControl]="filter"
        />
        <button
          type="button"
          class="btn btn-sm btn-input-group"
          (click)="clearSearch()"
        >
          <fa-icon [icon]="icons.times"></fa-icon>
        </button>
      </div>
      <button
        type="button"
        [disabled]="!adminService.isReady"
        [routerLink]="['add']"
        class="btn btn-outline-info btn-sm d-none d-md-block"
      >
        <fa-icon [icon]="icons.add"></fa-icon>
      </button>
    </div>
  </form>
  <p></p>
  <div>
    <ngb-alert
      type="info"
      [hidden]="this.adminService.isReady"
      [dismissible]="false"
      ><fa-icon [icon]="icons.spinner" animation="spin-pulse"></fa-icon>
      Reloading Sites...</ngb-alert
    >
    <table
      class="table table-sm table-striped table-bordered table-row-detail table-hover"
    >
      <thead class="table-dark">
        <tr>
          <th></th>
          <th>
            <div class="clearfix">
              <div class="float-start pt-2">
                <span class="">Site Name</span>
              </div>
              <div class="float-end">
                <button
                  type="button"
                  [disabled]="!adminService.isReady"
                  class="btn btn-sm btn-info d-block d-md-none"
                  [routerLink]="['add']"
                >
                  <fa-icon [icon]="icons.add"></fa-icon>
                </button>
              </div>
            </div>
          </th>
          <th class="d-none d-md-table-cell">Server Name</th>
          <th class="d-none d-md-table-cell">Server Version</th>
          <th class="d-none d-lg-table-cell">Last Sync</th>
        </tr>
      </thead>
      <tbody>
        @for (site of filteredSites | async; track site; let i = $index) {
          <tr [routerLink]="[site.Id]">
            <td>
              @if (site.HasError === true) {
                <fa-icon
                  [icon]="icons.exclamation"
                  class="text-danger"
                  title="{{ site.ErrorMessage }}"
                ></fa-icon>
              } @else if (site.HasError === false) {
                <fa-icon
                  [icon]="icons.circleCheck"
                  class="text-success"
                  title="Site is healthy"
                ></fa-icon>
              } @else {
                <fa-icon
                  [icon]="icons.spinner"
                  animation="spin-pulse"
                  class="text-muted"
                  title="Checking site..."
                ></fa-icon>
              }
            </td>
            <td>
              {{ site.Name }}
            </td>
            <td class="d-none d-md-table-cell">
              {{ site.CameraServerName?.toUpperCase() }}
            </td>
            <td class="d-none d-md-table-cell">{{ site.ServerVersion }}</td>
            <td class="d-none d-lg-table-cell">
              {{ site.LastSync | date: "short" }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
</div>
